export default __webpack_public_path__ + "static/media/Bucket.f4dc0696.svg";